var MODES;
(function (MODES) {
    MODES["UPLOADING"] = "uploading";
    MODES["BROWSING"] = "browsing";
})(MODES || (MODES = {}));
export default MODES;
